<template>

    <div>

        <div class="row row-cols-1 row-cols-md-2 g-4 mb-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <legend>{{ __('Details') }}</legend>

                        <table class="table table-bordered" v-if="order">
                            <tbody>
                                <tr>
                                    <th>{{ __('Supplier') }}</th>
                                    <td>{{ order.supplier.short_name }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <template v-if="!order">
                            <select-input label="customer" v-model="form.customer_id" :error="form.errors.customer_id">
                                <option :value="null">{{ __('Bitte wählen') }}</option>
                                <option :value="customer.id" v-for="customer in customers">{{ customer.name }} ({{ customer.customer_number }})</option>
                            </select-input>
                        </template>
                        <select-input label="order_status" v-model="form.order_status" :error="form.errors.order_status">
                            <option :value="k" v-for="(v, k) in orderStatusOptions">{{ v }}</option>
                        </select-input>
                        <text-input label="Lieferanten-Bestellnr." v-model="form.supplier_order_number" :error="form.errors.supplier_order_number" />
                        <text-input label="customer_number" v-model="form.customer_number" :error="form.errors.customer_number" />
                        <text-input type="datetime-local" label="Bestelldatum" v-model="form.order_date" :error="form.errors.order_date" />
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Statusänderung') }}</legend>

                            <div class="alert alert-primary" v-if="form.order_status === 'completed' ">
                                {{ __('Die Bestellung ist abgeschlossen.') }}
                            </div>

                            <template v-if="order">

                                <div class="d-grid gap-3">
                                    <template v-if="form.order_status === 'new' ">
                                        <inertia-link :href="route('admin.orders.update-order-status', {order, status: 'confirmed'})" 
                                                      class="btn btn-success w-100" 
                                                      as="button"
                                                      type="button">
                                            <strong>
                                                {{ __('Bestellung bestätigen') }}
                                            </strong>
                                            <span class="d-block small">
                                                {{ __('Sendet eine Bestellbestätigung an den Kunden.') }}
                                            </span>
                                        </inertia-link>
                                    </template>
                                    <template v-if="form.order_status !== 'processing' ">
                                        <inertia-link :href="route('admin.orders.update-order-status', {order, status: 'processing'})" 
                                                      class="btn btn-outline-info w-100" 
                                                      as="button"
                                                      type="button">
                                            {{ __('Bestellung in Bearbeitung') }}
                                        </inertia-link>
                                    </template>
                                    <template v-if="form.order_status !== 'completed' ">
                                        <inertia-link :href="route('admin.orders.update-order-status', {order, status: 'completed'})" 
                                                      class="btn btn-outline-secondary w-100" 
                                                      as="button"
                                                      type="button">
                                            {{ __('Bestellung abgeschlossen') }}
                                        </inertia-link>
                                    </template>
                                </div>

                            </template>
                            <!--                       @todo     <div>
                                                            <inertia-link href="#!" type="button" as="button" class="btn btn-secondary">
                                                                {{ __('E-Mail an Kunde senden') }}
                                                            </inertia-link>
                                                        </div>-->


                        </fieldset>
                    </div>
                </div>
            </div>


            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Rechnungsadresse') }}</legend>

                            <!--@todo Create address-->
                            <!--                            <div class="mb-3">
                                                            <inertia-link :href="route('admin.addresses.index')">
                                                                {{ __('Adresse auswählen') }}
                                                            </inertia-link>
                                                        </div>-->

                            <div class="row row-cols-1 row-cols-sm-2">
                                <div class="col w-100">
                                    <select-input label="country" v-model="form.billing_address_data.country_id" >
                                        <option :value="null">{{ __('Bitte wählen') }}</option>
                                        <option :value="country.id" v-for="country in countries">{{ country.name }}</option>
                                    </select-input>
                                </div>
                                <div class="col w-100">
                                    <text-input label="company" v-model="form.billing_address_data.company" />
                                </div>
                                <div class="col">
                                    <text-input label="salutation" v-model="form.billing_address_data.salutation" />
                                </div>
                                <div class="col">
                                    <text-input label="title" v-model="form.billing_address_data.title" />
                                </div>
                                <div class="col">
                                    <text-input label="first_name" v-model="form.billing_address_data.first_name" />
                                </div>
                                <div class="col">
                                    <text-input label="last_name" v-model="form.billing_address_data.last_name" />
                                </div>
                                <div class="col w-100">
                                    <div class="row">
                                        <div class="col-sm-8">
                                            <text-input label="street" v-model="form.billing_address_data.street" />
                                        </div>
                                        <div class="col-sm-4">
                                            <text-input label="house_number" v-model="form.billing_address_data.house_number" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col w-100">
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <text-input label="zip_code" v-model="form.billing_address_data.zip_code" />
                                        </div>
                                        <div class="col-sm-8">
                                            <text-input label="city" v-model="form.billing_address_data.city" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <text-input label="county" v-model="form.billing_address_data.county" />
                                </div>
                                <div class="col">
                                    <text-input label="phone" v-model="form.billing_address_data.phone" type="tel" />
                                </div>
                                <div class="col w-100">
                                    <textarea-input label="notes" v-model="form.billing_address_data.notes" />
                                </div>
                            </div>

                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Lieferadresse') }}</legend>

                            <!--                        @todo    <div class="mb-3">
                                                            <inertia-link :href="route('admin.addresses.index')">
                                                                {{ __('Adresse auswählen') }}
                                                            </inertia-link>
                                                        </div>-->

                            <checkbox-input label="Entspricht Rechnungsadresse" 
                                            value="1" 
                                            v-model="form.delivery_address_same_as_billing_address" />

                            <div v-if="!form.delivery_address_same_as_billing_address">
                                <div class="row row-cols-1 row-cols-sm-2">
                                    <div class="col w-100">
                                        <select-input label="country" v-model="form.delivery_address_data.country_id" >
                                            <option :value="null">{{ __('Bitte wählen') }}</option>
                                            <option :value="country.id" v-for="country in countries">{{ country.name }}</option>
                                        </select-input>
                                    </div>
                                    <div class="col w-100">
                                        <text-input label="company" v-model="form.delivery_address_data.company" />
                                    </div>
                                    <div class="col">
                                        <text-input label="salutation" v-model="form.delivery_address_data.salutation" />
                                    </div>
                                    <div class="col">
                                        <text-input label="title" v-model="form.delivery_address_data.title" />
                                    </div>
                                    <div class="col">
                                        <text-input label="first_name" v-model="form.delivery_address_data.first_name" />
                                    </div>
                                    <div class="col">
                                        <text-input label="last_name" v-model="form.delivery_address_data.last_name" />
                                    </div>
                                    <div class="col w-100">
                                        <div class="row">
                                            <div class="col-sm-8">
                                                <text-input label="street" v-model="form.delivery_address_data.street" />
                                            </div>
                                            <div class="col-sm-4">
                                                <text-input label="house_number" v-model="form.delivery_address_data.house_number" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col w-100">
                                        <div class="row">
                                            <div class="col-sm-4">
                                                <text-input label="zip_code" v-model="form.delivery_address_data.zip_code" />
                                            </div>
                                            <div class="col-sm-8">
                                                <text-input label="city" v-model="form.delivery_address_data.city" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <text-input label="county" v-model="form.delivery_address_data.county" />
                                    </div>
                                    <div class="col">
                                        <text-input label="phone" v-model="form.delivery_address_data.phone" type="tel" />
                                    </div>
                                    <div class="col w-100">
                                        <textarea-input label="notes" v-model="form.delivery_address_data.notes" />
                                    </div>
                                </div>
                            </div>

                        </fieldset>
                    </div>
                </div>
            </div>

            <div class="col w-100">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Produkte') }}</legend>

                            <div v-for="(orderItem, orderItemIndex) in form.order_items" class="bg-light p-3 mb-3 rounded-3">
                                <div class="row">
                                    <div class="col-auto">
                                        {{ orderItemIndex + 1 }}
                                    </div>
                                    <div class="col-2">
                                        <img class="img-fluid" 
                                             :src="orderItem.product.main_image_url"
                                             :alt="orderItem.product_name"
                                             loading="lazy" 
                                             v-if="orderItem.product" />
                                    </div>
                                    <div class="col-8">
                                        <div class="row">
                                            <div class="col-5">
                                                <text-input label="supplier_pid" v-model="orderItem.supplier_pid" :error="form.errors[`order_items.${orderItemIndex}.supplier_pid`]" />
                                            </div>
                                            <div class="col-7">
                                                <text-input label="product_name" v-model="orderItem.product_name" :error="form.errors[`order_items.${orderItemIndex}.product_name`]" />
                                            </div>
                                        </div>
                                        <div class="row align-items-center">
                                            <div class="col-3">
                                                <!--{{ orderItem.quantity }}-->
                                                <text-input type="number" min="0" label="quantity" v-model="orderItem.quantity" :error="form.errors[`order_items.${orderItemIndex}.quantity`]" />
                                            </div>
                                            <div class="col-3">
                                                <!--{{ orderItem.price | localizeAmount }}-->
                                                <price-input label="price" v-model="orderItem.price" :error="form.errors[`order_items.${orderItemIndex}.price`]" />
                                            </div>
                                            <div class="col-3">
                                                <!--{{ orderItem.price_quantity }}-->
                                                <!--@todo interval-->
                                                <text-input type="number" min="1" label="price_quantity" v-model="orderItem.price_quantity" :error="form.errors[`order_items.${orderItemIndex}.price_quantity`]" disabled readonly />
                                            </div>
                                            <div class="col-3">
                                                <percent-input label="tax_rate" v-model="orderItem.tax_rate" :error="form.errors[`order_items.${orderItemIndex}.tax_rate`]" />
                                            </div>

                                        </div>

                                        <div v-if="orderItem.product">

                                            <div class="border border-danger p-3 rounded-3">
                                                <div class="fw-bold mb-3">
                                                    {{ __('Vom Lieferanten auszufüllen. Diese Daten werden zum MDR-Tool übertragen.') }}
                                                </div>
                                                <!--                                                <div class="row">
                                                                                                    <div class="col-3">
                                                                                                        <checkbox-input label="MDR-klassifiziert" v-model="orderItem.product.mdr_classified" />
                                                                                                    </div>
                                                                                                    <div class="col-3">
                                                                                                        <checkbox-input label="Gefahrgut" v-model="orderItem.product.hazardous_material" />
                                                                                                    </div>
                                                                                                </div>-->

                                                <div v-for="(batch, batchIndex) in orderItem.data.batches">
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <text-input label="batch_number" v-model="batch.batch_number" :error="form.errors[`order_items.${orderItemIndex}.data.batches.${batchIndex}.batch_number`]" />
                                                        </div>
                                                        <div class="col-4">
                                                            <text-input type="date" label="expiration_date" v-model="batch.expiration_date" :error="form.errors[`order_items.${orderItemIndex}.data.batches.${batchIndex}.expiration_date`]" />
                                                        </div>
                                                        <div class="col-auto d-flex align-items-center">
                                                            <button type="button" class="btn btn-outline-danger" @click="removeOrderItemDataBatch(orderItemIndex, batchIndex)">
                                                                <i class="bi bi-x-lg"></i>
                                                                {{ __('Entfernen') }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <button type="button" class="btn btn-outline-secondary" @click="addOrderItemDataBatch(orderItemIndex)">
                                                    <i class="bi bi-plus-lg"></i>
                                                    {{ __('Charge hinzufügen') }}
                                                </button>
                                            </div>

                                        </div>

                                    </div>
                                    <!--                                    <div class="col-1">
                                                                            <button type="button" class="btn btn-outline-danger" @click="deleteOrderItem(orderItemIndex)">
                                                                                {{ __('Entfernen') }}
                                                                            </button>
                                                                        </div>-->
                                </div>

                            </div>

                            <!--                          @todo
                            <div class=" mb-3">
                                                            <button type="button" class="btn btn-outline-secondary" @click="addOrderItem()">
                                                                {{ __('Produkt hinzufügen') }}
                                                            </button>
                                                        </div>-->

                            <!--                       @todo     <form class="row row-cols-lg-auto g-3 align-items-center">
                                                            <div class="col-12">
                                                                <div class="input-group">
                                                                    <input type="search" class="form-control" placeholder="Produkt suchen" />
                                                                    <button class="btn btn-secondary" type="button">
                                                                        {{ __('Hinzufügen') }}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </form>-->

                            <div class="border border-danger mb-3 p-3 rounded-3">
                                <div class="fw-bold mb-3">
                                    {{ __('Vom Lieferanten auszufüllen') }}
                                </div>
                                <checkbox-input label="shipped" 
                                                value="1" 
                                                v-model="form.shipped"
                                                @change="setShippingDate" />
                                <div class="row">
                                    <div class="col-md-6">
                                        <text-input type="datetime-local" label="shipping_date" v-model="form.shipping_date" :error="form.errors.shipping_date"
                                                    />        
                                    </div>
                                </div>

                                <text-input type="url" label="tracking_url" v-model="form.tracking_url" :error="form.errors.tracking_url" />
                                <text-input label="tracking_code" v-model="form.tracking_code" :error="form.errors.tracking_code" />
                            </div>



                            <table class="table table-sm">
                                <tbody>
                                    <tr>
                                        <th class="text-end">{{ __('Gesamt netto') }}</th>
                                        <td class="text-end">{{ form.subtotal | localizeAmount }}</td>
                                    </tr>
                                    <tr>
                                        <th class="text-end">{{ __('MwSt.') }}</th>
                                        <td class="text-end">{{ form.tax | localizeAmount }}</td>
                                    </tr>
                                    <tr>
                                        <th class="text-end">{{ __('Versandkosten') }}</th>
                                        <td class="text-end">{{ form.delivery | localizeAmount }}</td>
                                    </tr>
                                    <tr>
                                        <th class="text-end">{{ __('Delivery tax') }}</th>
                                        <td class="text-end">{{ form.delivery_tax | localizeAmount }}</td>
                                    </tr>
                                    <tr>
                                        <th class="text-end fs-5">{{ __('Gesamt inkl MwSt.') }}</th>
                                        <td class="text-end fw-bold fs-5">{{ form.total | localizeAmount }}</td>
                                    </tr>
                                </tbody>
                            </table>

                        </fieldset>

                    </div>
                </div>
            </div>

            <div class="col w-100">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Sonstiges') }}</legend>
                            <textarea-input label="notes" v-model="form.notes" :error="form.errors.notes" />
                        </fieldset>
                    </div>
                </div>
            </div>

            <!--        @todo orderNotes fertigstellen    <div class="col w-100">
                            <div class="card">
                                <div class="card-body">
                                    <fieldset>
                                        <legend>{{ __('Bemerkungen') }}</legend>
                                        <fieldset>
                                            <legend>{{ __('Sonstiges') }}</legend>
                                            <textarea-input label="text" v-model="form.order_notes.text" :error="form.errors.notes" />
                                        </fieldset>
                                        <div class="bg-light p-3 mb-3" v-for="orderNote in order.orderNotes">
                                            <div>
                                                {{ orderNote.text }}
                                            </div>
                                            <div class="mt-1 small text-secondary">
                                                {{ orderNote.created_at | localizeDateTime }}
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>
                        </div>-->

        </div>

        <!--@todo show change log-->

        <div class="d-flex align-items-center gap-3 w-100">
            <submit-button :form="form" />
            <button type="button" class="btn link-danger" @click="destroy" v-if="order">
                {{ __('Put in trash') }}
            </button>
        </div>

    </div>

</div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import PriceInput from '@/shared/Inputs/PriceInput';
    import PercentInput from '@/shared/Inputs/PercentInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';

    export default {
        props: [
            'form',
            'order',
            'countries',
            'customers',
            'orderStatusOptions',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            SelectInput,
            TextareaInput,
            PriceInput,
            PercentInput,
            CheckboxInput,
            SubmitButton,
            DataTable,
            DataTableRow,
        },
        watch: {
        },
        methods: {
            setShippingDate() {
                if (!this.form.shipping_date) {
                    this.form.shipping_date = moment().format('YYYY-MM-DDTHH:mm');
                }
            },
            addOrderItem() {
                if (this.form.order_items.length >= 100) {
                    alert('Sie können maximal 100 Produkte angeben.');
                    return false;
                }

                const orderItem = {
                    product: {},
                    data: {batches: []},
                };
                this.form.order_items.push(orderItem);
            },
            addOrderItemDataBatch(index) {
                if (this.form.order_items[index].data.batches >= 100) {
                    alert('Sie können maximal 100 Einträge angeben.');
                    return false;
                }

                const batch = {
                };
                this.form.order_items[index].data.batches.push(batch);
            },
            removeOrderItemDataBatch(orderItemIndex, index) {
                Vue.delete(this.form.order_items[orderItemIndex].data.batches, index);
            },
            deleteOrderItem(index) {
                Vue.delete(this.form.order_items, index);

//                if (confirm(this.__('Sind Sie sicher?'))) {
//                    this.$inertia.delete(this.route('admin.orders.delete-order-item', id));
//                }
            },
            destroy() {
                this.$inertia.delete(this.route('admin.orders.destroy', this.order));
            },
        },
    }
</script>
